import Swiper from "swiper";
import { EffectCards, EffectCoverflow, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { reloadCopyright } from "./copyright";

export function activateHomepageSlider() {
  const elements = document.querySelectorAll(".ce-homepage-slider .swiper-container");

  for (const element of elements) {
    createSwiper(element as HTMLElement);
  }
}

function createSwiper(element: HTMLElement) {
  let slideCount = Number.parseInt(element.dataset.slideCount);
  let swiperInstance;

  function getEffect() {
    return window.matchMedia("(max-width: 768px)").matches ? 'cards' : 'coverflow';
  }

  function getEffectConfig(effect) {
    if (effect === 'coverflow') {
      return {
        coverflowEffect: {
          rotate: 0,
          stretch: -20,
          depth: 200,
          modifier: 1.2,
          slideShadows: false,
          scale: 1, // Skaliert nicht aktive Slides auf 80%
        },
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: -80, // Geringerer Abstand für bessere Überlappung
        breakpoints: {
          1300: {
            slidesPerView: 1.5,
          },
        },
      };
    } else if (effect === 'cards') {
      return {
        stretch: 0,
        modifier: 1,
        spaceBetween: 30,
      };
    }
    return {};
  }

  function initializeSwiper() {
    const effect = getEffect();
    swiperInstance = new Swiper(element, {
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".ce-homepage-slider--pagination",
        clickable: true,
      },
      modules: [EffectCoverflow, EffectCards, Navigation, Pagination, Autoplay],
      effect: effect,
      loop: slideCount >= 4,
      ...getEffectConfig(effect),
      on: {
        slideChange: () => {          
          reloadCopyright();
        },
        progress: function () {
          this.slides.forEach((slide) => {
            let slideProgress = slide.progress;
            let scale = 1 - Math.min(Math.abs(slideProgress) * 0.2, 0.2); // Skaliert die Nachbarbilder auf 80%
            slide.style.transform = `scale(${scale}) translateZ(-10px)`; // Positioniert die kleineren Bilder hinter dem großen Bild
            slide.style.zIndex = Math.round((1 - Math.abs(slideProgress)) * 10); // Stellt sicher, dass das aktive Bild vorne ist
          });
        },
      },
    });
  }

  initializeSwiper();

  window.addEventListener('resize', () => {
    const newEffect = getEffect();
    if (swiperInstance && swiperInstance.params.effect !== newEffect) {
      swiperInstance.destroy(true, true);
      initializeSwiper();
    }
  });
}
